import script from "./kxOnceImg1.vue?vue&type=script&setup=true&lang=js"
export * from "./kxOnceImg1.vue?vue&type=script&setup=true&lang=js"

import "./kxOnceImg1.vue?vue&type=style&index=0&id=7691e7f8&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7691e7f8"]])

export default __exports__